import type { ExperimentClient } from '@amplitude/experiment-js-client'
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser'
import { isSupportWindow } from '@/utils'

export interface IAnalyticsState {
    customerio: AnalyticsBrowser | null
    experiment: ExperimentClient | null
}

export const getInitialAnalyticsState = (): IAnalyticsState => {
    const proxiedUrl = import.meta.env.VUE_APP_CIO_ANALYTICS_URL

    const customerio = import.meta.env.VUE_APP_CIO_WRITE_KEY
        && !isSupportWindow()
        && window.isSecureContext
        && AnalyticsBrowser.load({
            writeKey: import.meta.env.VUE_APP_CIO_WRITE_KEY,
            cdnURL: proxiedUrl,
        }, {
            integrations: {
                'Customer.io In-App Plugin': {
                    anonymousInApp: true,
                },
                ...(proxiedUrl
                    ? {
                        'Customer.io Data Pipelines': {
                            apiHost: 'cioanalytics.pocketprep.com/v1',
                        },
                    }
                    : {}),
            },
        })

    return {
        customerio: customerio || null,
        experiment: null,
    }
}

const moduleState = getInitialAnalyticsState()

export default moduleState
